/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAccountMappingByID, getAccountMappingForUserID, getAccountMappingHistory, getAllAccountMappings } from './mappingAction';

const initialState = {
    data: {},
    mappings: {},
    mappingsHistory: {},
    mappingsHistoryByUser: {}

}
const mappingSlice = createSlice({
    name: 'mapping',
    initialState,
    extraReducers: {

        [getAllAccountMappings.fulfilled]: (state, { payload }) => {
            state.mappings = payload;
        },
        [getAccountMappingHistory.fulfilled]: (state, { payload }) => {
            state.mappingsHistory = payload;
        },
        [getAccountMappingHistory.rejected]: (state, { payload }) => {
            state.mappingsHistory = {};
        },
        [getAccountMappingForUserID.fulfilled]: (state, { payload }) => {
            state.mappingsHistoryByUser = payload;
        },
        [getAccountMappingByID.fulfilled]: (state, { payload }) => {
            state.mappings = payload;
        },
    }
});

export default mappingSlice.reducer